export const ENV = 'staging';
export const BASE_URL = 'https://basecamp.staging.ropeup.fr';
export const FRONT_URL = 'https://widget.staging.ropeup.fr/';
export const IMG_BASE_URL = 'https://basecamp.staging.ropeup.fr/';
